import React, { Component } from 'react'

import Section from './Section'
import Parallax from './Parallax'

class Sections extends Component {


    render() {

        const { sections } = this.props




        return (
            <div>
                {sections.map((section, index) => {

                    const { id } = section.sys.contentType.sys

                    if (id === "section") {
                        return <Section {...section} key={index} />
                    }
                    
                    if (id === "parallax") {
                        return <Parallax {...section} key={index} />
                    }

                    return <div key={index}>no match</div>

                })}

            </div>

        );
    }
}


export default Sections;